
export default class Consts {

    static EMAIL_REGEX = /^([\w!#$%&'*+\/=?^`{|}~-]+(?:\.[\w!#$%&'*+\/=?^`{|}~-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([A-Za-z]{2,63}(?:\.[A-Za-z]{2})?)$/i;

}
